import { IShipToCustomerItem } from '../../../services/EntryOrder';

export enum Types {
  LOAD_RECEIVERS = 'entry-order/LOAD_RECEIVERS',
  LOAD_RECEIVERS_FROM_CUSTOMER = 'entry-order/LOAD_RECEIVERS_FROM_CUSTOMER',
  LOAD_RECEIVERS_LOADING = 'entry-order/LOAD_RECEIVERS_LOADING',
  LOAD_RECEIVERS_SUCCESS = 'entry-order/LOAD_RECEIVERS_SUCCESS'
}

export interface IEntryOrderReceivers {
  customerId: string;
  receivers: IShipToCustomerItem[];
  loading: boolean;
}
